import ServicesPortal from "@/services/portal/ServicesPortal";
import InativacaoLotePreviewModel from "@/models/empresa/InativacaoLotePreviewModel";
import InativacaoLoteStatusModel from "@/models/empresa/InativacaoLoteStatusModel";

/**
 * @summary Camada Axios do fluxo de inativação/transferência em lote de
 * sub-dados de Empresa (Contatos, Siglas CCEE, UCs).
 *
 * Endpoints: GET /template-excel, POST /preview (multipart),
 * POST /confirmar, GET /status.
 */
class EmpresaInativacaoLoteService extends ServicesPortal {
  getTemplateExcel(request) {
    this._url = "/template-excel";
    return this.getAttachment(request);
  }

  preview(request) {
    this._url = "/preview";
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.post(request, false, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        response.data = new InativacaoLotePreviewModel(response.data);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  confirmar(request) {
    this._url = "/confirmar";
    return this.post(request);
  }

  getStatus(request) {
    this._url = "/status";
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.get(request);
        response.data = new InativacaoLoteStatusModel(response.data);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default new EmpresaInativacaoLoteService("empresas/inativacao-lote");
